<template><div><h1 id="artikel-hitliste" tabindex="-1"><a class="header-anchor" href="#artikel-hitliste"><span>Artikel-Hitliste</span></a></h1>
<p>Artikel-Hitliste — Verkaufs-Hitliste</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei mit den verkauften Artikeln. Je nach Wunsch kann diese nach Anzahl meistverkaufter Artikeln, oder nach Umsatzstärksten Artikeln sortiert werden. Retouren werden nicht abgezogen, damit das ursprüngliche Bestellvolumen ersichtlich wird. Hingegen Artikel aus zurückgesetzten Fakturen (Faktura zurücksetzen) werden wieder abgezogen. Eingeschränkt werden kann nach Fakturadatum und Anzahl aufzulistender Artikel. Falls die Artikel durch einen Seperator in Sub- und Hauptartikel unterteilt sind, können diese mittels einem vordefinierten Filter selektiert werden. Zusätzlich können die Artikel nach PM (Productmanager) und Medium gefiltert werden. Es ist möglich, das Ausgabeformat zu wählen (Text / Excel). Die Artikel werden je nach Auswahl, nach Anzahl verkaufter oder Umsatzstärksten Einheiten absteigend sortiert.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikel-Hitliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<dl>
<dt>Fakturadatum von</dt>
<dd>Fakturadatum von, leer = unbegrenzt</dd>
<dt>bis</dt>
<dd>Fakturadatum bis, leer = unbegrenzt</dd>
<dt>Filter</dt>
<dd>Filtern nach Haupt- oder Subartikel</dd>
<dt>Produckt Manager</dt>
<dd>Filtern nach Product Manager; Stern = alle</dd>
<dt>Medium</dt>
<dd>Filtern nach Medium; Stern = alle</dd>
<dt>Auftragsarten</dt>
<dd>Filtern nach Auftragsart; Stern = alle</dd>
<dt>Anzahl maximal</dt>
<dd>Anzahl der maximal aufzulistenden Artikel</dd>
<dt>Sortieren nach</dt>
<dd>Sortieren nach Anzahl oder Umsatz</dd>
<dt>Ausgabe</dt>
<dd>Standardausgabe</dd>
</dl>
<h2 id="output" tabindex="-1"><a class="header-anchor" href="#output"><span>Output</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Artikel</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikelbezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>verkauft</td>
<td>Anzahl verkaufter Artikel</td>
</tr>
<tr>
<td>Verkaufspreis</td>
<td>Verkaufspreis aus Artikelstamm</td>
</tr>
<tr>
<td>Umsatz</td>
<td>Gesamtumsatz pro Artikel</td>
</tr>
<tr>
<td>Rabatt in %</td>
<td>Durchschnittlich gewährter Rabatt in %</td>
</tr>
</tbody>
</table>
</div></template>


